exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-to-cart[data-v-2d2e6996]{\n  display: -ms-flexbox;\n  display: flex;\n}\ni[data-v-2d2e6996]{\n  margin-right: 5px;\n  width: 24px;\n  height: 24px;\n  overflow: hidden;\n}\n", ""]);

// exports
